/**
 * Created by Ning Jiang on 6/20/2018.
 */

import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {FruitsParsedGameData} from "../server/data/FruitsParsedGameData";

export class StickyRespinZeroBetController extends ZeroBetController {

    constructor() {
        super();
    }

    protected getZeroBetNumberLeft(data:ParsedServerData):number {
        return -1;
    }

    public shouldSubtractZeroBetCounter():boolean {
        return false;
    }

    public shouldShowZeroBetCounter():boolean {
        return false;
    }

    protected calculateIsTriggered(data:FruitsParsedGameData):boolean {
        const isNextFirstStickyRespin:boolean = data.isStickyRespinTriggeredThisSpin != null ? data.isStickyRespinTriggeredThisSpin : false;
        const isNextContinueStickyRespin:boolean = data.nextMode === FruitsGameMode.STICKY_RESPIN;
        return data.isStickyRespinTriggeredThisSpin && data.nextMode !== FruitsGameMode.STICKY_RESPIN ? false : isNextFirstStickyRespin || isNextContinueStickyRespin;
    }
}